/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MdRippleModule} from '../ripple/index';
import {MdPseudoCheckboxModule} from '../selection/index';
import {MdOption} from './option';
import {MdOptgroup} from './optgroup';
export class MdOptionModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [MdRippleModule, CommonModule, MdPseudoCheckboxModule],
  exports: [MdOption, MdOptgroup],
  declarations: [MdOption, MdOptgroup]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdOptionModule_tsickle_Closure_declarations() {
/** @type {?} */
MdOptionModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdOptionModule.ctorParameters;
}



export {MdOptionSelectionChange,MdOption} from './option';
export {MdOptgroupBase,_MdOptgroupMixinBase,MdOptgroup} from './optgroup';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
